<template>
<div class="alert-status">
    <el-alert class="alert_display" :type="alertType" show-icon :closable="false">
      <slot>
        <div class="density_level">{{ message }}</div>
        <div class="density_level_under">密集度設定人数：{{ threshold }} 人</div>
      </slot>
    </el-alert>
</div>
</template>

<script>

export default {
  props: {
      densityLevel: {
        default: "",
      },
      threshold: {
        default: "",
      }
  },

  computed: {
    alertType() {
      if (this.densityLevel === "高"){
        return "error"
      } else if (this.densityLevel === "中") {
        return "warning"
      } 
      return "success"
    },

    message() {
      if (this.densityLevel === "高"){
        return "過密状態です。"
      } else if (this.densityLevel === "中") {
        return "警戒が必要です。"
      } 
      return "過密状態ではありません。"
    },
  }
  
}

</script>
    
<style scoped>

.density_level {
    text-align: left;
    padding: 30px;
    font-size: 20px;
}

.density_level_under {
    text-align: left;
    padding: 15px 30px;
    font-size: 14px;
}

.alert_display {
    padding: 20;
    font-size: 20px;
}
</style>